import React from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';

const TicketStatusField = ({ source, record = {} }) => {
    const translate = useTranslate();
    return (
        <span>{ translate(`resources.tickets.status.${record[source]}`) } </span>
      );
};

TicketStatusField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default TicketStatusField;
